<template>
  <b-input-group>
    <b-input-group-prepend is-text>
      <font-awesome-icon icon="user" />
    </b-input-group-prepend>
    <b-select 
      :value="selectedValue" 
      :options="inspecteurOptions"
      :state="state"
      @input="onInput"
    >
      <template #first>
        <b-form-select-option
          :value="null"
          disabled
        >
          -- GEEN --
        </b-form-select-option>
      </template>
    </b-select>
    <b-input-group-append v-if="!eigenGroepAlleen">
      <b-form-radio-group
        v-model="selectedGroupFilter"
        :options="groupOptions"
        buttons
        button-variant="outline-secondary"
      />
    </b-input-group-append>
  </b-input-group>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
    name: "InspecteurSelect",
    mixins: [serviceMixin],
    props: {
        value: {
            type: [Object, Number],
            default: null,
        },
        required: {
            type: Boolean,
            default: null,
        },
        // API endpoint waar de lijst vandaan komt (standaard de inspecteurs lijst)
        endpoint: {
            type: String,
            default: "inspecteurs",
        },
        // Maak ook beheerders selecteerbaar (standaard zijn deze disabled)
        allowBeheerders: {
            type: Boolean,
            default: false,
        },
        // Toon alleen de eigen groep van de ingelogde gebruiker (verbergt het groepsfilter)
        eigenGroepAlleen: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            inspecteurs: [],
            opt_groups: true,
            selectedGroupFilter: null,
        };
    },
    computed: {
        state: function () {
            if (this.required) {
                return this.selectedValue !== null;
            }
            return null;
        },

        selectedValue: function () {
            // Handle object format {id, naam} of {Id, Naam} -> convert to id
            if (this.value && typeof this.value === 'object') {
                return this.value.id || this.value.Id || null;
            }
            // Handle new format (already an id)
            return this.value;
        },
        groupOptions: function () {
            // Unique group names from loaded inspecteurs
            const groups = [...new Set(
                this.inspecteurs.map((i) => i.groep || "Onbekend")
            )].sort();
            return [
                { text: "Alle", value: null },
                ...groups.map((g) => ({ text: g, value: g })),
            ];
        },
        filteredInspecteurs: function () {
            // Bij eigenGroepAlleen: toon uitsluitend de eigen groep van de gebruiker
            if (this.eigenGroepAlleen) {
                const eigenGroep = this.eigenGroep;
                if (!eigenGroep) {
                    return this.inspecteurs;
                }
                return this.inspecteurs.filter(
                    (i) => (i.groep || "Onbekend") === eigenGroep
                );
            }
            if (!this.selectedGroupFilter) {
                return this.inspecteurs;
            }
            return this.inspecteurs.filter(
                (i) => (i.groep || "Onbekend") === this.selectedGroupFilter
            );
        },
        eigenGroep: function () {
            const user = this.$store.getters.user;
            return (user && user.advies) || null;
        },
        inspecteurOptions: function () {
            // if opt_groups is true, group inspecteurs by groep
            if (this.opt_groups) {
                return Object.entries(
                    this.filteredInspecteurs.reduce((groups, inspecteur) => {
                        // Use a default group label if groep is undefined or null
                        const groep = inspecteur.groep || "Onbekend";
                        groups[groep] = groups[groep] || [];
                        groups[groep].push(inspecteur);
                        return groups;
                    }, {})
                ).map(([label, options]) => ({
                    label, // Group label
                    options, // Grouped options
                }));
            } else {
                // Return a flat list of options if opt_groups is false
                return this.filteredInspecteurs.map((inspecteur) => {
                    return inspecteur;
                });
            }
        },
    },
    mounted() {
        this.loadInspecteurs();
    },
    methods: {
        async loadInspecteurs() {
            await this.get(this.endpoint).then((response) => {
                // Pak de eerste array uit de response
                const data = response.data || {};
                const lijst = Array.isArray(data)
                    ? data
                    : (Object.values(data).find((v) => Array.isArray(v)) || []);
                this.inspecteurs = lijst.map((item) => this.normalize(item));
                this.applyDefaultGroupFilter();
            }).catch((error) => {
                console.error(`Fout bij laden van ${this.endpoint}:`, error);
            });
        },
        // Normaliseer items naar het {value, text, groep} formaat.
        // Ondersteunt naast het standaard formaat ook {Id, Naam, Functie, Groep}.
        normalize(item) {
            var normalized = item;
            if (!item || item.value === undefined) {
                normalized = {
                    value: item.Id,
                    text: item.Functie ? `${item.Naam} (${item.Functie})` : item.Naam,
                    groep: item.Groep || "Onbekend",
                };
            }
            // Maak beheerders selecteerbaar indien toegestaan
            if (this.allowBeheerders && normalized.disabled) {
                normalized = { ...normalized, disabled: false };
            }
            return normalized;
        },
        // Zet het groepsfilter standaard op de groep van de ingelogde gebruiker (indien aanwezig in de lijst)
        applyDefaultGroupFilter() {
            const eigenGroep = this.eigenGroep;
            if (
                eigenGroep &&
                this.inspecteurs.some((i) => (i.groep || "Onbekend") === eigenGroep)
            ) {
                this.selectedGroupFilter = eigenGroep;
            }
        },
        onInput(selectedId) {
            // Find the inspecteur by id and emit the old format {id, naam}
            const inspecteur = this.inspecteurs.find(i => i.value === selectedId);
            if (inspecteur) {
                this.$emit('input', { id: inspecteur.value, naam: inspecteur.text.split(' (')[0] });
            } else {
                this.$emit('input', null);
            }
        },
    }

};
</script>